import { useConfiguratorStore } from '@/state/configuratorStore';

const STEPS = [
  { id: 0, label: '01 Design', short: 'Design' },
  { id: 1, label: '02 Roster', short: 'Roster' },
  { id: 2, label: '03 Quote', short: 'Quote' },
] as const;

export function WizardSteps() {
  const step = useConfiguratorStore(s => s.step);
  const setStep = useConfiguratorStore(s => s.setStep);

  return (
    <nav className="wizard" aria-label="Configurator steps">
      <ol className="wizard__list">
        {STEPS.map(s => (
          <li key={s.id}>
            <button
              type="button"
              className={`wizard__step${step === s.id ? ' is-active' : ''}${s.id < step ? ' is-done' : ''}`}
              onClick={() => setStep(s.id)}
              aria-current={step === s.id ? 'step' : undefined}
            >
              <span className="wizard__num">{s.label}</span>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
}
